var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.modalAction
    ? _c(
        "b-modal",
        {
          ref: "purchase-return-invoice-rma-approve-modal",
          attrs: {
            id: "purchaseReturnInvoiceRmaApproveModal",
            title: _vm.modalAction.Title,
            size: "xl",
            "no-close-on-backdrop": ""
          },
          on: { close: _vm.closed },
          scopedSlots: _vm._u(
            [
              {
                key: "modal-footer",
                fn: function() {
                  return [
                    _c(
                      "div",
                      { staticClass: "w-100 text-right" },
                      [
                        _c(
                          "b-button",
                          {
                            attrs: { variant: "danger", size: "sm" },
                            on: {
                              click: function($event) {
                                return _vm.closeModal()
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n        " +
                                _vm._s(_vm.$t("index.close")) +
                                "\n      "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-button",
                          {
                            attrs: {
                              variant: "primary",
                              disabled: _vm.showLoading || _vm.disabledButton,
                              size: "sm"
                            },
                            on: {
                              click: function($event) {
                                return _vm.submitModal()
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n        " +
                                _vm._s(_vm.$t("index.approve")) +
                                "\n        "
                            ),
                            _vm.showLoading
                              ? _c("b-spinner", {
                                  attrs: { small: "", variant: "primary" }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              }
            ],
            null,
            false,
            356940321
          )
        },
        [
          _c(
            "section",
            [
              _c(
                "b-row",
                [
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        title: _vm.$t(
                          "index.PurchaseReturnInvoice.ApproveNumber"
                        ),
                        md: "4",
                        lg: "4"
                      }
                    },
                    [
                      _c("b-form-input", {
                        attrs: { type: "text" },
                        model: {
                          value: _vm.approveNumber,
                          callback: function($$v) {
                            _vm.approveNumber = $$v
                          },
                          expression: "approveNumber"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticClass: "text-right" },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "primary", size: "sm" },
                          on: {
                            click: function($event) {
                              return _vm.search()
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("index.search")) +
                              "\n        "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.showInvoiceLines
                ? _c(
                    "b-row",
                    { staticClass: "mt-2" },
                    [
                      _c(
                        "b-col",
                        [
                          _vm.invoiceLines
                            ? _c("b-table", {
                                attrs: {
                                  items: _vm.invoiceLines,
                                  fields: _vm.fields,
                                  "sticky-header": "",
                                  busy: _vm.tableBusy,
                                  "select-mode": "single",
                                  selectable: ""
                                },
                                on: { "row-selected": _vm.onRowSelected },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "head()",
                                      fn: function(data) {
                                        return [
                                          _vm._v(
                                            "\n            " +
                                              _vm._s(_vm.$t(data.label)) +
                                              "\n          "
                                          )
                                        ]
                                      }
                                    },
                                    {
                                      key: "table-busy",
                                      fn: function() {
                                        return [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-center text-danger my-2"
                                            },
                                            [
                                              _c("b-spinner", {
                                                staticClass: "align-middle"
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      },
                                      proxy: true
                                    },
                                    {
                                      key: "cell(selected)",
                                      fn: function(ref) {
                                        var rowSelected = ref.rowSelected
                                        return [
                                          rowSelected
                                            ? [
                                                _c(
                                                  "span",
                                                  {
                                                    attrs: {
                                                      "aria-hidden": "true"
                                                    }
                                                  },
                                                  [_vm._v("✓")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  { staticClass: "sr-only" },
                                                  [_vm._v("Selected")]
                                                )
                                              ]
                                            : [
                                                _c(
                                                  "span",
                                                  {
                                                    attrs: {
                                                      "aria-hidden": "true"
                                                    }
                                                  },
                                                  [_vm._v(" ")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  { staticClass: "sr-only" },
                                                  [_vm._v("Not selected")]
                                                )
                                              ]
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  229343404
                                )
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _vm.showRmaLines
            ? _c(
                "section",
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t("index.Convert.Code"),
                            md: "4",
                            lg: "4",
                            error: _vm.$v.form.InvoiceNumber
                          }
                        },
                        [
                          _c("b-form-input", {
                            attrs: { type: "text" },
                            model: {
                              value: _vm.form.InvoiceNumber,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "InvoiceNumber", $$v)
                              },
                              expression: "form.InvoiceNumber"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t("index.Convert.DocumentNumber"),
                            md: "4",
                            lg: "4",
                            error: _vm.$v.form.DocumentNumber
                          }
                        },
                        [
                          _c("b-form-input", {
                            attrs: { type: "text" },
                            model: {
                              value: _vm.form.DocumentNumber,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "DocumentNumber", $$v)
                              },
                              expression: "form.DocumentNumber"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.type !== "Waybill"
                        ? _c(
                            "NextFormGroup",
                            {
                              attrs: {
                                title: _vm.$t("index.Convert.InvoiceKindId"),
                                error: _vm.$v.form.DocumentClassId,
                                required: false,
                                md: "4",
                                lg: "4"
                              }
                            },
                            [
                              _c("v-select", {
                                attrs: {
                                  options: _vm.invoiceTypes,
                                  label: "label"
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.selectedType(
                                      "DocumentClassId",
                                      $event
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.invoiceType,
                                  callback: function($$v) {
                                    _vm.invoiceType = $$v
                                  },
                                  expression: "invoiceType"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t("index.Convert.Warehouse"),
                            md: "4",
                            lg: "4",
                            error: _vm.$v.form.WarehouseId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              source: _vm.warehouses,
                              searchable: true,
                              "custom-option": true,
                              disabled: false
                            },
                            on: { input: _vm.selectedWarehouse },
                            model: {
                              value: _vm.warehouse,
                              callback: function($$v) {
                                _vm.warehouse = $$v
                              },
                              expression: "warehouse"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          _vm.rmaLines
                            ? _c("b-table", {
                                attrs: {
                                  items: _vm.rmaLines,
                                  fields: _vm.fieldsRma,
                                  "sticky-header": ""
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "head()",
                                      fn: function(data) {
                                        return [
                                          _vm._v(
                                            "\n            " +
                                              _vm._s(_vm.$t(data.label)) +
                                              "\n          "
                                          )
                                        ]
                                      }
                                    },
                                    {
                                      key: "cell(UsedQuantity)",
                                      fn: function(row) {
                                        return [
                                          _c("b-form-input", {
                                            attrs: {
                                              type: "number",
                                              min: 0,
                                              max: row.item.UsedQuantity
                                            },
                                            model: {
                                              value: row.item.UsedQuantity,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  row.item,
                                                  "UsedQuantity",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "row.item.UsedQuantity"
                                            }
                                          })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  3098354771
                                )
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0abc9c2c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0abc9c2c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Actions/PurchaseReturnInvoiceRmaApproveModal.vue
// module id = null
// module chunks = 